var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.title ? 'main--container' : 'main--container-without-title'},[_c('div',{staticClass:"not-italic font-normal text-zt-xl leading-8 flex items-center text-zt-primary-200"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }